"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDerivedCompositionInfo = getDerivedCompositionInfo;
const chemical_elements_1 = require("chemical-elements");
const mf_parser_1 = require("mf-parser");
/**
 * Calcultes informations about the isotopic composition explaining a specific mass
 * @param {Record<string, number>} composition
 * @returns
 */
function getDerivedCompositionInfo(composition) {
    const shortComposition = {};
    let label = '';
    let shortLabel = '';
    for (let key in composition) {
        let isotopeLabel = '';
        for (let i = 0; i < key.length; i++) {
            if (mf_parser_1.superscript[key[i]]) {
                isotopeLabel += mf_parser_1.superscript[key[i]];
            }
            else {
                isotopeLabel += key[i];
            }
        }
        if (composition[key] > 1) {
            const number = String(composition[key]);
            for (let i = 0; i < number.length; i++) {
                isotopeLabel += mf_parser_1.subscript[number[i]];
            }
        }
        label += isotopeLabel;
        if (chemical_elements_1.stableIsotopesObject[key].mostAbundant)
            continue;
        shortLabel += isotopeLabel;
        shortComposition[key] = composition[key];
    }
    return { label, shortComposition, shortLabel };
}
//# sourceMappingURL=getDerivedCompositionInfo.js.map